export const cimmplePayDocsOverviewMarkdown = `# CimmplePay Integration Docs

This is the starter documentation set for external ERP and implementation partners integrating with CimmplePay.

These docs are intentionally simpler than large vendor portals, and focus on practical integration outcomes:

- authenticate and call APIs safely
- sync employees and payroll data
- retrieve payroll outputs
- optionally sync accounting journals

## Suggested website URL

When you publish on \`cimmple.com\`, use a stable location such as:

- \`https://cimmple.com/docs/cimmplepay\`

## Document map

- \`getting-started.md\` - base URLs, environments, and first API call
- \`authentication.md\` - JWT login, token usage, and company context
- \`core-flows.md\` - recommended integration workflows
- \`api-quick-reference.md\` - high-value endpoints with examples
- \`go-live-checklist.md\` - readiness and production launch checklist

## Source of truth

For complete endpoint discovery and request/response models, use the live OpenAPI/Swagger document exposed by the API service:

- \`/swagger\`
- \`/swagger/v1/swagger.json\`

## Version

- Documentation version: \`v1\`
- Product: \`CimmplePay\`
`;
